import { Actions, State, Types } from './types'

export const reducer = (state: State, action: Actions): State => {
  switch (action.type) {
    case Types.SetExample:
      return { ...state, example: action.payload } // fake

    default:
      return state
  }
}
